<template>
  <transition v-show="value" name="fade" mode="out-in">
    <div v-if="value || computeSlot" class="maskPopup" @click.stop="close">
      <div class="wrapper" :class="{ has_title }">
        <div v-if="title || hasClose" class="title">
          <div
            v-if="hasCancel"
            class="previousButton iconBtn"
            @click.stop="$emit('cancel')"
          >
            <i class="fas fa-chevron-left" />
          </div>
          <span>{{ title }}</span>
          <div v-if="hasClose" class="closeBtn iconBtn" @click.stop="close">
            <i class="fas fa-times" />
          </div>
        </div>
        <div class="content" :class="{ noScrollbar: noScrollSar }" @click.stop>
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default() {
        return ""
      },
    },
    computeSlot: {
      type: Boolean,
      required: false,
    },
    hasCancel: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
    hasClose: {
      type: Boolean,
      required: false,
      default() {
        return true
      },
    },
    noScrollSar: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      escape_event_handler: null,
    }
  },
  computed: {
    has_title() {
      return typeof this.title === "string" && this.title.length
    },
  },
  mounted() {
    this.$on("close", () => {
      this.$emit("input", false)
    })
  },
  destroyed() {
    if (this.escape_event_handler !== null) {
      window.document.removeEventListener("keydown", this.escapeEventHandler)
      this.escapeEventHandler = null
    }
  },
  methods: {
    close() {
      this.$emit("input", false)
      this.$emit("close")
    },
  },
}
</script>

<style scoped src="./modal.css"></style>
